<template>
  <div @click="buttonClicked" class="round-button" :type="type"
       :class="gradient ? 'ground-button-gradient' : 'round-button-normal'">
    <div class="row align-items-center">
      {{ label }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "RoundButton",
  props: ['label', 'gradient', 'type'],
  methods: {
    buttonClicked() {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="scss">


.ground-button-gradient {
  border: 1px solid rgb(79, 161, 218);
  color: white;
  background: rgb(79, 161, 218) !important;
  background: linear-gradient(90deg, rgba(39, 104, 179, 1) 0%, rgba(79, 161, 218, 1) 100%) !important;
}

.round-button-normal {
  border: 1px solid #979797;
  color: black;
}

.round-button-normal[type="danger"] {
  border: 1px solid #ff0000;
  color: #ff0000;
}

.ground-button-gradient[type="danger"] {
  border: 1px solid #ff0000;
  color: white;
  background: #ff0000 !important;
  background: linear-gradient(90deg,  #ff0000 0%,  #ab0303 100%) !important;
}

.round-button {
  border-radius: 30px;
  font-size: 19px;
  font-weight: 500;
  padding: 10px 24px 10px 24px;
  text-align: center;
  cursor: pointer;
}

.round-button:hover {
  opacity: 0.8;
}

.round-button:active {
  opacity: 0.85;
}
</style>
